import {
  Wrapper,
  And,
  Separator,
  ExitButton
} from './Styles'

import Logo from 'components/StaticIcons/Logo'
import GetGameLogo from 'components/_utils/GetGameLogo'
import { IGamesName } from 'interfaces/IGames'
import Navigation from './Navigation'
import Avatar from 'components/Avatar'
import LogoutIcon from 'components/StaticIcons/Navigation/Logout'

interface props {
  game: IGamesName
}

export default function Menu({ game }: props) {
  return (
    <Wrapper>
      <Logo />
      <And>X</And>
      <GetGameLogo game={game} />
      <br />
      <Separator />

      <Navigation />
      <Avatar src="https://theprime.gg/favicon.ico" size="small" />

      <ExitButton>
        <LogoutIcon />
      </ExitButton>
    </Wrapper>
  )
}